import cssText from '@plugins/inlineManual/style.css?inline';

let sheet = null;

const getSheet = () => {
    if (!sheet && typeof CSSStyleSheet === 'function' && typeof CSSStyleSheet.prototype.replaceSync === 'function') {
        sheet = new CSSStyleSheet();
        sheet.replaceSync(cssText);
    }

    return sheet;
};

/**
 * Adopts the Inline Manual overrides into `root` (the document or a shadow root). Idempotent.
 *
 * @param {Document|ShadowRoot} root
 */
export const ensureInlineManualStyles = root => {
    const styles = getSheet();
    if (!styles || !root?.adoptedStyleSheets || root.adoptedStyleSheets.includes(styles)) {
        return;
    }

    root.adoptedStyleSheets = [...root.adoptedStyleSheets, styles];
};
